module.exports = __webpack_public_path__ + "img/Banco-Ripley.a53d055a.svg";